import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_TABS = createFcmDetails('starter_experience_dashboard_tabs', {
	owner: 'Starter Experience',
	context: 'Starter Petition Dashboard',
	description:
		'If true, the users are treated into an A/B testing experiment to show a different layout on the dashboard to include Tabs',
	template: {
		isEnabled: false,
		experiment: 'starter_experience_dashboard_tabs_v03',
	},
	import: false,
});
